import { GatewayApi } from './base';
import { toBase64, Constructor } from '../common';

class SqlFiltersImpl {
    constructor(
        readonly id?: string,
        readonly author?: string,
        readonly sql_query?: string,
        readonly tag?: string,
    ) {}
}

export interface SqlFiltersEvent extends SqlFiltersImpl { }

export class SqlFiltersApi extends GatewayApi {
    constructor() {
        super('SqlFilters');
    }

    async index() {
        const res = await this.invoke('index', {});
        return res
    }

    async write(sqlData: object) {
        let author = ''

        if (this.user)
        {
            author = this.user.name.join();
        }

        return this.invoke('write', { author: author, data: sqlData });
    }


    async delete(id: string) {
        const res = await this.invoke('remove', {id});
        return res
    }



}
